import { render, staticRenderFns } from "./IndagineEpidemiologicaInfluenzaEditComponent.vue?vue&type=template&id=3b523e2a"
import script from "./IndagineEpidemiologicaInfluenzaEditComponent.vue?vue&type=script&lang=js"
export * from "./IndagineEpidemiologicaInfluenzaEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports